// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    display: flex;
    height: 100vh;
    width: 100%;
}

.logo-section {
    width: 40%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
    text-align: center;
}

.logo-section img {
    max-width: 80%;
}

.login-section {
    width: 60%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 2rem;
    position: relative;
}

.login-form {
    width: 100%;
    max-width: 400px;
    position: relative;
    margin-bottom: 100px;
}

.alert-section {
    padding: 1rem;
    border-radius: 6px;
    border: 2px solid #111827;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.absolute-alert {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 400px;
    z-index: 1000;
}

.red-alert {
    background-color: #f8a6a6;
    color: #b90202;
}

.yellow-alert {
    background-color: #f8f1a6;
    color: #b0ad03;
}

.alert-section h4 {
    margin: 0 0 0.5rem 0;
}

.alert-section p {
    margin: 0;
}

.login-form h1 {
    margin-bottom: 2rem;
}

.login-form button {
    width: 100%;
    margin-top: 18px;
}

@media (max-width: 768px) {
    .logo-section {
        display: none;
    }
    
    .login-section {
        width: 100%;
    }
} `, "",{"version":3,"sources":["webpack://./src/assets/login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,WAAW;AACf;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".login-container {\n    display: flex;\n    height: 100vh;\n    width: 100%;\n}\n\n.logo-section {\n    width: 40%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0 2rem;\n    text-align: center;\n}\n\n.logo-section img {\n    max-width: 80%;\n}\n\n.login-section {\n    width: 60%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0 2rem;\n    position: relative;\n}\n\n.login-form {\n    width: 100%;\n    max-width: 400px;\n    position: relative;\n    margin-bottom: 100px;\n}\n\n.alert-section {\n    padding: 1rem;\n    border-radius: 6px;\n    border: 2px solid #111827;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.absolute-alert {\n    position: absolute;\n    top: 80px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 100%;\n    max-width: 400px;\n    z-index: 1000;\n}\n\n.red-alert {\n    background-color: #f8a6a6;\n    color: #b90202;\n}\n\n.yellow-alert {\n    background-color: #f8f1a6;\n    color: #b0ad03;\n}\n\n.alert-section h4 {\n    margin: 0 0 0.5rem 0;\n}\n\n.alert-section p {\n    margin: 0;\n}\n\n.login-form h1 {\n    margin-bottom: 2rem;\n}\n\n.login-form button {\n    width: 100%;\n    margin-top: 18px;\n}\n\n@media (max-width: 768px) {\n    .logo-section {\n        display: none;\n    }\n    \n    .login-section {\n        width: 100%;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
